import React from 'react';

import css from './Complete.module.scss';

export default function CreditCompleteImage({ creditApplication }) {
  const src = creditApplication.creditAccepted
    ? '../../../static/credit_accepted_complete.svg'
    : '../../../static/credit_complete_nonaccepted.svg';
  return (
    <div className={css.CreditCompleteImageContainer}>
      <div className={css.CreditImageBackground}>
        <img src={src} />
      </div>
    </div>
  );
}
